/* @jsx h */
import { defineComponent, h } from "vue";
import { useLocalization } from "@lemmonhq/uikit";
import { DEPARTMENTS, type Department } from "./types";

type Props = {
  value: Department | null;
  /** Only show departments that are in use. */
  used?: string[];
  onChange: (value: Department | null) => void;
};

// "Show all" plus one tab per department.
export const DepartmentTabs = defineComponent<Props>({
  name: "DepartmentTabs",
  props: ["value", "used", "onChange"],
  setup(props) {
    const { t } = useLocalization();
    return () => {
      const shown = DEPARTMENTS.filter((d) => !props.used || props.used.includes(d));
      return (
        <div role="tablist" class="join">
          {[null, ...shown].map((d) => (
            <button
              key={d ?? "all"}
              role="tab"
              class={["btn join-item btn-sm", props.value === d ? "btn-active bg-base-100 shadow-sm" : "btn-ghost border-base-300 text-base-content/70"].join(" ")}
              onClick={() => props.onChange(d)}
            >
              {d ? t(`workday.department.${d}`) : t("workday.common.show_all")}
            </button>
          ))}
        </div>
      );
    };
  },
});
